// extracted by mini-css-extract-plugin
export default {"grid":"tpv_grid__Pposn"};